import { connect } from 'react-redux';
import withRouter from 'shared/helper/with-router';
import { addMessage } from 'researcher/application/actions';
import { getProviders } from 'researcher/application/reducer';
import { loginUser } from '../actions';
import { getReferringUrl, getOtherLocalizationLogoutLinks, getLoginMessage } from '../reducer';
import Login from './Login';
var mapStateToProps = function mapStateToProps(_ref, _ref2) {
  var application = _ref.application,
    authentication = _ref.authentication,
    user = _ref.user;
  var match = _ref2.match,
    location = _ref2.location;
  return {
    failureMessage: match.params.message ? decodeURI(match.params.message.replace(/\+/g, ' ')) : null,
    localAuthEnabled: application.config.localAuthEnabled,
    loginMessage: getLoginMessage({
      location: location
    }),
    otherLocalizationLogoutLinks: getOtherLocalizationLogoutLinks({
      application: application
    }),
    providers: getProviders({
      application: application
    }),
    referringUrl: getReferringUrl({
      location: location
    }),
    status: authentication.status,
    user: user
  };
};
export default withRouter(connect(mapStateToProps, {
  addMessage: addMessage,
  loginUser: loginUser
})(Login));